module.exports = __webpack_public_path__ + "img/Perks-75.b568a54d.png";